<template>
    <div class="list-header px-4 pt-4 pb-3">
        <div class="d-flex align-items-center gap-1">
            <div class="search-box chat-search-box w-100">
                <div class="input-group rounded-5">
                    <span class="input-group-text text-muted bg-light pe-1 ps-3 border-0" style="border-radius: 20px 0px 0px 20px !important;">
                        <i class="ri-search-line search-icon font-size-18"></i>
                    </span>
                    <input type="text" class="form-control bg-light border-0" placeholder="Pesquisar..."
                        :value="modelValue" @input="emitSearch" style="border-radius: 0px 20px 20px 0px !important;"
                        autocomplete="off" name="search_chats_input">
                </div>
            </div>

            <template v-if="!internalChatStore.isInternalChatMode">
                <VDropdown :distance="10" placement="bottom-end" :triggers="['click']">
                    <button type="button" class="btn btn-light px-2 ms-2 shadow-sm border position-relative" title="Filtros de Atendimento">
                        <i class="ri-filter-3-line"></i>
                        <span v-if="generalFiltersCount > 0" class="filter-badge">{{ generalFiltersCount }}</span>
                    </button>
                    <template #popper>
                        <div class="filter-dropdown-content custom-scrollbar">
                            <h6 class="dropdown-header-v text-primary">Status</h6>
                            <div class="dropdown-item-v-check">
                                <div class="form-check p-0 m-0">
                                    <input class="form-check-input" type="checkbox" v-model="chatStore.listFilters.naoLidos" id="f-unread">
                                    <label class="form-check-label" for="f-unread">Não lidos</label>
                                </div>
                            </div>
                            <div class="dropdown-item-v-check">
                                <div class="form-check p-0 m-0">
                                    <input class="form-check-input" type="checkbox" v-model="emEspera" id="f-em-espera">
                                    <label class="form-check-label" for="f-em-espera">
                                        <span class="text-truncate" v-tooltip="'Somente atendimentos em espera: os que piscam na lista, sem atendente vinculado'">Em espera</span>
                                    </label>
                                </div>
                            </div>

                            <div class="dropdown-divider-v"></div>
                            <h6 class="dropdown-header-v text-primary">Automações</h6>
                            <div class="dropdown-item-v-check">
                                <div class="form-check p-0 m-0">
                                    <input class="form-check-input" type="checkbox" v-model="chatStore.listFilters.botAvaliacao" id="f-bot-avaliacao">
                                    <label class="form-check-label" for="f-bot-avaliacao">
                                        <span class="text-truncate" v-tooltip="'Bot de avaliação'">Bot de avaliação</span>
                                    </label>
                                </div>
                            </div>
                            <div class="dropdown-item-v-check">
                                <div class="form-check p-0 m-0">
                                    <input class="form-check-input" type="checkbox" v-model="automacoes.iniciadoComIa" id="f-ia-iniciado">
                                    <label class="form-check-label" for="f-ia-iniciado">
                                        <span class="text-truncate" v-tooltip="'Atendimento iniciado com IA'">Atendimento iniciado com IA</span>
                                    </label>
                                </div>
                            </div>
                            <!-- Rótulo trunca e revela o texto inteiro no tooltip: comprido
                                 demais, ele esticava a linha e deformava o checkbox. -->
                            <div class="dropdown-item-v-check">
                                <div class="form-check p-0 m-0">
                                    <input class="form-check-input" type="checkbox" v-model="automacoes.finalizadoPorIa" id="f-ia-finalizado">
                                    <label class="form-check-label" for="f-ia-finalizado">
                                        <span class="text-truncate" v-tooltip="'Atendimento considerado finalizado pela IA'">Atendimento considerado finalizado pela IA</span>
                                    </label>
                                </div>
                            </div>

                            <!-- Atendimento criado por campanha fica OCULTO por padrão: sem
                                 escolher a campanha aqui, ele não aparece em lugar nenhum. -->
                            <div class="px-3 pt-2 pb-1 filtro-campanha">
                                <label class="font-size-11 text-muted fw-semibold d-block mb-1">Atendimentos de uma campanha</label>
                                <SelectField
                                    v-model="campanhaSelecionada"
                                    :options="opcoesCampanha"
                                    value-prop="id"
                                    label-option="nome"
                                    place-holder="Selecione uma campanha..."
                                />
                                <div v-if="!opcoesCampanha.length" class="font-size-11 text-muted mt-1">
                                    Nenhuma campanha com atendimento em aberto.
                                </div>
                            </div>
                            <!-- Só fazem sentido com uma campanha em foco: sem ela não há
                                 o que restringir. -->
                            <template v-if="temCampanhaEmFoco">
                                <div class="dropdown-item-v-check">
                                    <div class="form-check p-0 m-0">
                                        <input class="form-check-input" type="checkbox" v-model="automacoes.criadosPorCampanha" id="f-campanha-criados">
                                        <label class="form-check-label" for="f-campanha-criados">
                                            <span class="text-truncate" v-tooltip="'Criados por esta campanha'">Criados por esta campanha</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="dropdown-item-v-check">
                                    <div class="form-check p-0 m-0">
                                        <input class="form-check-input" type="checkbox" v-model="automacoes.tocadosPorCampanha" id="f-campanha-tocados">
                                        <label class="form-check-label" for="f-campanha-tocados">
                                            <span class="text-truncate" v-tooltip="'Tocados por esta campanha'">Tocados por esta campanha</span>
                                        </label>
                                    </div>
                                </div>
                            </template>

                            <template v-for="({ agent, ehEu, cabecalho }) in agentesComCabecalho" :key="agent.id">
                                <template v-if="cabecalho">
                                    <div class="dropdown-divider-v"></div>
                                    <h6 class="dropdown-header-v text-primary">{{ cabecalho }}</h6>
                                </template>
                                <div class="dropdown-item-v-check">
                                    <div class="form-check d-flex gap-2 align-items-center p-0 m-0">
                                        <input v-if="ehEu" class="form-check-input flex-shrink-0 m-0" type="checkbox" v-model="chatStore.listFilters.meus" id="f-mine">
                                        <input v-else class="form-check-input flex-shrink-0 m-0" type="checkbox" :value="agent.id" v-model="chatStore.listFilters.selectedAgentIds" :id="`f-team-${agent.id}`">
                                        <div class="tiny-avatar-container">
                                            <img :src="agent.foto || branding.images.avatarFallback" class="rounded-circle tiny-avatar-img" alt="Avatar" loading="lazy">
                                        </div>
                                        <label class="form-check-label d-flex flex-column flex-grow-1 overflow-hidden ps-0" :for="ehEu ? 'f-mine' : `f-team-${agent.id}`">
                                            <span class="text-truncate">{{ agent.nome }}</span>
                                            <!-- Status na linha do próprio usuário não diz nada: ele
                                                 está online por definição. Para o root, que não é
                                                 destacado, a própria linha (se existir) é da equipe
                                                 e mostra o status como qualquer outra. -->
                                            <span v-if="!ehEu" class="agent-status-label" :class="isAgentOnline(agent.id) ? 'text-success' : 'text-muted'">
                                                {{ isAgentOnline(agent.id) ? 'Online' : 'Offline' }}
                                            </span>
                                        </label>
                                        <span v-if="getAtendenteUnreadCount(agent.id) > 0" class="badge bg-danger rounded-pill flex-shrink-0 ms-auto" style="font-size: 10px;">
                                            {{ getAtendenteUnreadCount(agent.id) }}
                                        </span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </VDropdown>

                <!-- <VDropdown v-permission="'conta.visualizar_etiquetas'" :distance="10" placement="bottom-end" :triggers="['click']">
                    <button type="button" class="btn btn-light px-2 ms-1 shadow-sm border position-relative" title="Filtrar Etiquetas">
                        <i class="ri-price-tag-3-line"></i>
                        <span v-if="chatStore.selectedTagIds?.length > 0" class="filter-badge">{{ chatStore.selectedTagIds?.length }}</span>
                    </button>
                    <template #popper>
                        <div class="filter-dropdown-content">
                            <div class="p-2 border-bottom">
                                <li v-permission="['conta.inserir_etiquetas']" style="list-style: none;">
                                    <button class="btn btn-sm btn-primary w-100 d-flex align-items-center justify-content-center gap-2" @click="handleCreateTagClick" v-close-popper>
                                        <i class="ri-add-line"></i> Nova Etiqueta
                                    </button>
                                </li>
                            </div>
                        </div>
                    </template>
                </VDropdown> -->

                <VDropdown v-permission="'conta.visualizar_etiquetas'" :distance="10" placement="bottom-end" :triggers="['click']">
                    <button type="button" class="btn btn-light px-2 ms-1 shadow-sm border position-relative" title="Filtrar Etiquetas">
                        <i class="ri-price-tag-3-line"></i>
                        <span v-if="chatStore.listFilters.selectedTagIds?.length > 0" class="filter-badge">{{ chatStore.listFilters.selectedTagIds?.length }}</span>
                    </button>
                    <template #popper>
                        <div class="filter-dropdown-content">
                            <div class="p-2 border-bottom">
                                <li v-permission="['conta.inserir_etiquetas']" style="list-style: none;">
                                    <button class="btn btn-sm btn-primary w-100 d-flex align-items-center justify-content-center gap-2" @click="handleCreateTagClick" v-close-popper>
                                        <i class="ri-add-line"></i> Nova Etiqueta
                                    </button>
                                </li>
                            </div>
                            <div class="custom-scrollbar" style="max-height: 300px;">
                                <div v-for="tag in availableTags" :key="tag.id" class="dropdown-item-v-check">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" :value="tag.id" v-model="chatStore.listFilters.selectedTagIds" :id="`f-tag-${tag.id}`">
                                        <label class="form-check-label d-flex align-items-start gap-2 w-100" :for="`f-tag-${tag.id}`">
                                            <i class="ri-price-tag-3-fill flex-shrink-0 mt-1" :style="{ color: tag.cor }"></i>
                                            <span style="word-break: break-word; white-space: normal;">{{ tag.nome }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </VDropdown>

                <VDropdown :distance="10" placement="bottom-end" :triggers="['click']">
                    <button type="button" class="btn btn-light px-2 ms-1 shadow-sm border position-relative" title="Filtrar por Inbox">
                        <i class="ri-inbox-2-fill text-success"></i>
                        <span v-if="chatStore.listFilters.selectedInboxIds?.length > 0" class="filter-badge">{{ chatStore.listFilters.selectedInboxIds?.length }}</span>
                    </button>
                    <template #popper>
                        <div class="filter-dropdown-content custom-scrollbar">
                            <!-- "Suas instâncias", não "Instâncias Conectadas": `availableInboxes`
                                 é `authStore.currentAccountInboxes`, que lista os inboxes aos quais
                                 o usuário está VINCULADO na conta atual e que têm integração
                                 configurada. O estado de conexão não entra no critério em momento
                                 algum — um inbox caído continua aparecendo aqui, e deve mesmo: as
                                 conversas dele seguem na lista e precisam ser filtráveis. -->
                            <h6 class="dropdown-header-v text-primary">Suas Instâncias</h6>
                            <div v-for="inbox in availableInboxes" :key="inbox.id" class="dropdown-item-v-check">
                                <div class="form-check d-flex align-items-center gap-2 p-0 m-0">
                                    <input class="form-check-input flex-shrink-0 m-0" style="position: static;" type="checkbox" :value="inbox.id" v-model="chatStore.listFilters.selectedInboxIds" :id="`f-inbox-${inbox.id}`">
                                    <label class="form-check-label d-flex align-items-center gap-2 flex-grow-1 overflow-hidden" :for="`f-inbox-${inbox.id}`" style="cursor: pointer;">
                                        <span class="text-truncate">{{ inbox.nome }}</span>
                                        <span v-if="getUnreadCount(inbox.id) > 0" class="badge bg-danger rounded-pill flex-shrink-0 ms-auto" style="font-size: 10px;">
                                            {{ getUnreadCount(inbox.id) }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div v-if="!availableInboxes?.length" class="p-3 text-center text-muted font-size-12">
                                Nenhuma instância encontrada.
                            </div>

                            <div class="dropdown-divider-v"></div>
                            <h6 class="dropdown-header-v text-primary">Canais</h6>
                            <template v-for="grouping in canaisByInbox" :key="grouping.idInbox">
                                <div v-if="grouping.canais.length > 0" class="mt-2 d-flex flex-row align-items-center w-100">
                                    <small class="fw-bold ms-2 ps-1 mb-2 me-2 text-muted text-truncate">{{ inboxNameById.get(grouping.idInbox) }}</small>
                                </div>
                                <template v-for="canal in grouping.canais" :key="canal.id">
                                    <div v-if="chatStore.listFilters.selectedInboxIds.length == 0 || chatStore.listFilters.selectedInboxIds.includes(grouping.idInbox)" class="dropdown-item-v-check">
                                        <div class="form-check d-flex align-items-center gap-2 p-0 m-0">
                                            <input class="form-check-input flex-shrink-0 m-0" style="position: static;" type="checkbox" :value="canal.id" v-model="chatStore.listFilters.selectedChannelIds" :id="`f-canal-${canal.id}`">
                                            <label class="form-check-label d-flex align-items-center gap-2 flex-grow-1 overflow-hidden" :for="`f-canal-${canal.id}`" style="cursor: pointer;">
                                                <span class="text-truncate">{{ canal.nome }}</span>
                                                <span v-if="getChannelUnreadCount(canal.id) > 0" class="badge bg-danger rounded-pill flex-shrink-0 ms-auto" style="font-size: 10px;">
                                                    {{ getChannelUnreadCount(canal.id) }}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div v-else class="dropdown-item-v-check pe-none">
                                        <div class="disabled pe-none text-muted form-check d-flex align-items-center gap-2 p-0 m-0">
                                            <i class="ri-prohibited-line fw-bold disabled pe-none flex-shrink-0 m-0"></i>
                                            <label class="form-check-label d-flex align-items-center gap-2 flex-grow-1 overflow-hidden" style="cursor: pointer;">
                                                <span class="text-truncate">{{ canal.nome }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </template>
                </VDropdown>
            </template>

            <!-- <VDropdown :distance="10" placement="bottom-end" :triggers="['hover', 'click']">
                <button type="button" class="btn btn-light px-2 ms-1 shadow-sm border position-relative text-info" title="Informação do Sistema">
                    <i class="ri-information-line"></i>
                </button>
                <template #popper>
                    <div class="p-3 shadow-sm bg-white rounded-3" style="max-width: 260px;">
                        <h6 class="font-size-13 fw-bold text-info mb-2 d-flex align-items-center gap-1">
                            <i class="ri-information-fill"></i> Limpeza Automática
                        </h6>
                        <p class="font-size-12 text-muted mb-0 lh-sm">
                            Atendimentos inativos por mais de <strong>1 semana</strong> são encerrados e removidos automaticamente pelo sistema para otimizar o desempenho.
                        </p>
                    </div>
                </template>
            </VDropdown> -->
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watchEffect, watch, onMounted } from 'vue'; // ref adicionado de volta
import { branding } from '@/config/branding';
import { useUiStore } from '@/stores/app/uiStore';
import { useTagStore } from '@/stores/app/tagStore'; 
import { useChatStore } from '@/stores/app/chatStore'; 
import { useInternalChatStore } from '@/stores/app/chatInternoStore';
import { vClosePopper } from 'floating-vue';
import { useAuthStoreUser } from '@/stores/app/authUser';
import { IdCanal, IdInbox, IdUsuario } from '@/services/common-types';
import { CanalService, ResponseCanal } from '@/services/canais/canais.service';
import { filtrarCanaisVisiveis } from '@/utils/canais-permitidos';
import { ResponseUsuario } from '@/services/usuarios/usuarios.service';
import { ContasService } from '@/services/contas/contas.service';
import { useCampanhasStore } from '@/stores/app/campanhas';
import SelectField from '@/components/forms/SelectField.vue';
import { contarFiltrosAutomacoes, ehAtendimentoOcultoPorCampanha, filtrosAutomacoesVazios, normalizarFiltrosAutomacoes } from '@/utils/campanhaAtendimento';

const uiStore = useUiStore();
const tagStore = useTagStore(); 
const chatStore = useChatStore();
const authStore = useAuthStoreUser();
const internalChatStore = useInternalChatStore();
const campanhasStore = useCampanhasStore();

defineProps({
    modelValue: String
});
const emit = defineEmits(['update:modelValue']);
async function emitSearch(event: Event) {
    emit('update:modelValue', (event.target as EventTarget & { value: any }).value)
}


/**
 * Instâncias do filtro: TODO inbox a que o usuário está vinculado na conta
 * atual, com `del = false` — tenha ou não integração configurada.
 *
 * Antes isto era só `currentAccountInboxes`, que sai de `inboxesFull` e portanto
 * do mapa `inboxes` do token — e aquele mapa só carrega inbox COM sub-registro
 * de integração, porque é de lá que saem as credenciais. O efeito era um inbox
 * perfeitamente vinculado sumir do filtro por não ter integração: um Meta criado
 * pelo admin e nunca conectado, um que perdeu a metade oficial num
 * `PARTNER_REMOVED`, ou um com `plataforma` nula.
 *
 * `inboxesVinculados` (who-am-i) é a lista completa e já vem escopada na conta.
 * Preferimos o objeto de `currentAccountInboxes` quando ele existe — traz o
 * inbox inteiro, útil para o resto da tela — e completamos com o rótulo
 * (id/nome) dos que só existem na lista de vínculos.
 */
const availableInboxes = computed(() => {
    const completos = authStore.currentAccountInboxes || [];
    const vinculados = authStore.inboxesVinculados || [];
    if (!vinculados.length) return completos;

    const porId = new Map(completos.map(i => [String(i.id), i]));
    return vinculados.map(v => porId.get(String(v.id)) ?? { id: v.id, nome: v.nome });
});
const availableTags = computed(() => tagStore.initialized ? tagStore.availableTags.filter(e => !e.del) : []);

watch(() => internalChatStore.isInternalChatMode, () => {
    emit('update:modelValue', '');
});

/**
 * Usuário root (acesso global) enxerga a conta inteira sem ser atendente dela.
 *
 * Para ele a separação "Meus Atendimentos" × "Atendimentos da Equipe" não faz
 * sentido: ou ele não está entre os vinculados — e aí não há "meu" nenhum a
 * destacar — ou está, mas como mais um da equipe. Sem esta distinção o bloco
 * degenerava: o cabeçalho da equipe saía DUAS vezes, porque a regra antiga
 * marcava os índices 0 e 1 contando com o "eu" ocupar o 0.
 */
const ehUsuarioRoot = computed(() => authStore.user?.hasGlobalAccess === true);

const availableAgents = ref<ResponseUsuario[]>([]);
watch(() => authStore.currentConta?.id, async (newAccountId) => {
    if (!newAccountId) return availableAgents.value = [];
    const agentes = await new ContasService().getUsuariosVinculados(newAccountId);

    // Puxar o próprio usuário para o topo só faz sentido quando ele é destacado.
    // Para o root a lista fica na ordem que o servidor mandou.
    if (!ehUsuarioRoot.value) {
        const currentUserIdx = agentes.findIndex(u => u.id == authStore.user?.id);

        if (currentUserIdx >= 0) {
            const [currentUser] = agentes.splice(currentUserIdx, 1);
            agentes.unshift(currentUser);
        }
    }

    // Reaproveita internalChatStore.contacts (já atualizado em tempo real via
    // WebSocket em CHAT_INTERNO.STATUS_USUARIO) para exibir online/offline
    // no filtro de colaboradores sem duplicar a chamada de status.
    if (!internalChatStore.contacts.length) {
        internalChatStore.fetchContacts();
    }

    return availableAgents.value = agentes
}, {immediate: true, deep: true})

const agentOnlineMap = computed(() => {
    const map = new Map<string, boolean>();
    internalChatStore.contacts.forEach((c) => {
        map.set(String(c.id).replace(/^contact-/, ''), !!c.isOnline);
    });
    return map;
});

function isAgentOnline(id: IdUsuario) {
    return agentOnlineMap.value.get(String(id)) ?? false;
}

/**
 * Lista com o cabeçalho de cada linha já resolvido.
 *
 * O cálculo saiu do template de propósito: lá era `i == 0 || i == 1`, que presume
 * o "eu" no índice 0. Quando ele não está lá — root, ou usuário fora dos
 * vinculados da conta — as DUAS condições passavam e o cabeçalho da equipe era
 * renderizado duas vezes. Aqui a regra está declarada: o "eu" abre a própria
 * seção, e o primeiro que não é "eu" abre a da equipe. Uma vez cada.
 */
const agentesComCabecalho = computed(() => {
    const meuId = authStore.user?.id;
    let equipeJaAberta = false;

    return availableAgents.value.map((agent) => {
        const ehEu = !ehUsuarioRoot.value && !!meuId && agent.id == meuId;

        let cabecalho: string | null = null;
        if (ehEu) {
            cabecalho = 'Meus Atendimentos';
        } else if (!equipeJaAberta) {
            cabecalho = 'Atendimentos da Equipe';
            equipeJaAberta = true;
        }

        return { agent, ehEu, cabecalho };
    });
});

/**
 * O root não tem caixa para o filtro `meus`, então um `true` herdado de outra
 * sessão ficaria filtrando a lista sem nada na tela explicando por quê — e sem
 * como desmarcar. `listFilters` é persistido em localStorage, então isso
 * atravessa reload.
 */
watch(ehUsuarioRoot, (root) => {
    if (root && chatStore.listFilters.meus) chatStore.listFilters.meus = false;
}, { immediate: true });

const canaisByInboxRaw = ref<{idInbox: IdInbox, canais: ResponseCanal[]}[]>([]);
watch(() => authStore.currentAccountInboxes, async (inboxes) => {
    canaisByInboxRaw.value = await new CanalService().getAllByManyInbox(inboxes.map(i => i.id))
}, {immediate: true, deep: true});

// Filtro de leitura: só canais cujos atendimentos o usuário enxerga de fato
// (vínculo, visualização global ou inbox.ver_todos_atendimentos), espelhando
// chatStore._podeVerAtendimento. `computed` porque as permissões chegam depois
// do fetch dos canais.
const canaisByInbox = computed(() => canaisByInboxRaw.value.map(
    ({ idInbox, canais }) => ({ idInbox, canais: filtrarCanaisVisiveis(idInbox, canais) })
));

const inboxNameById = computed(() => new Map(availableInboxes.value.map(i => [i.id, i.nome])));

watchEffect(() => authStore.initialized && authStore.currentConta?.id ? tagStore.init(authStore.currentConta.id) : null);

/**
 * Bloco "Automações" dos filtros. Acessado por um computed em vez de direto no
 * template porque filtros persistidos antes desta feature não têm o campo — sem o
 * fallback, os `v-model` escreveriam em `undefined`.
 */
const automacoes = computed(() => {
    const atual = chatStore.listFilters.automacoes;

    // Só substitui quando falta chave: um filtro salvo ANTES de "Todas" existir tem
    // o objeto `automacoes` presente e sem o campo novo, e estar presente era o
    // bastante para o fallback antigo (`if (!automacoes)`) nunca rodar.
    //
    // A guarda é obrigatória, não economia: `listFilters` tem watcher `deep` que
    // persiste a cada mudança, então escrever um objeto NOVO em toda leitura do
    // computed o invalidaria a si mesmo — leitura escreve, escrita invalida,
    // invalidação relê. Laço infinito.
    if (atual && Object.keys(filtrosAutomacoesVazios()).every(k => k in atual)) return atual;

    chatStore.listFilters.automacoes = normalizarFiltrosAutomacoes(atual);
    return chatStore.listFilters.automacoes;
});

/** Valor do seletor que representa "Todas as campanhas". */
const TODAS_CAMPANHAS = '__TODAS__';

/**
 * Trocar de campanha zera os checkboxes de tipo: eles são relativos à campanha em
 * foco, e mantê-los marcados esconderia metade da campanha nova sem explicação.
 *
 * A sentinela `__TODAS__` vive só aqui, na camada de UI: o filtro guarda
 * `todasCampanhas` num campo próprio. Sentinela dentro de um campo de id vaza
 * como id de verdade na primeira vez que alguém esquece de tratá-la.
 */
const campanhaSelecionada = computed({
    get: () => automacoes.value.todasCampanhas ? TODAS_CAMPANHAS : automacoes.value.idCampanha,
    set: (valor: string | null) => {
        automacoes.value.todasCampanhas = valor === TODAS_CAMPANHAS;
        automacoes.value.idCampanha = valor && valor !== TODAS_CAMPANHAS ? valor : null;
        automacoes.value.criadosPorCampanha = false;
        automacoes.value.tocadosPorCampanha = false;
    },
});

/** Há campanha em foco? "Todas" conta — é ela que revela os atendimentos ocultos. */
const temCampanhaEmFoco = computed(() => !!automacoes.value.idCampanha || automacoes.value.todasCampanhas);

// A lista vem do store, não de um fetch local: é ele que o CampanhasModal atualiza ao
// criar/editar/excluir uma campanha. Com um `ref` próprio, uma campanha recém-criada só
// aparecia aqui depois de recarregar a página.
watch(() => authStore.currentConta?.id, (idConta) => {
    if (idConta) void campanhasStore.get();
}, { immediate: true });

/**
 * Opções do seletor, achatadas com o nome do inbox no rótulo. O SelectField
 * (`@vueform/multiselect`) não expõe grupos, e prefixar o inbox mantém a origem
 * visível e ainda entra na busca por texto do próprio componente.
 */
const campanhasComAtendimentoAberto = computed(() => {
    const inboxesEmFoco = chatStore.listFilters.selectedInboxIds ?? [];

    return campanhasStore.campanhas
        .filter(c => !c.del && (!inboxesEmFoco.length || inboxesEmFoco.includes(c.idInbox)))
        // Campanha sem atendimento aberto não tem nada a revelar aqui: escolhê-la
        // esvaziaria a lista. `atendimentosAtivos` já implica "teve envio
        // executado" — a linha de vínculo só nasce depois do envio.
        .filter(c => (c.atendimentosAtivos ?? 0) > 0)
        .sort((a, b) => {
            const porInbox = (inboxNameById.value.get(a.idInbox) ?? '').localeCompare(inboxNameById.value.get(b.idInbox) ?? '');
            if (porInbox !== 0) return porInbox;
            return new Date(b.dataCriacao).getTime() - new Date(a.dataCriacao).getTime();
        });
});

/**
 * Opções do seletor, achatadas com o nome do inbox no rótulo. O SelectField
 * (`@vueform/multiselect`) não expõe grupos, e prefixar o inbox mantém a origem
 * visível e ainda entra na busca por texto do próprio componente.
 *
 * "Todas as campanhas" é a primeira opção: é o atalho para ver a fila de campanha
 * inteira sem ter que adivinhar qual delas trouxe o atendimento procurado.
 */
const opcoesCampanha = computed(() => {
    const campanhas = campanhasComAtendimentoAberto.value.map(c => ({
        id: c.id as string,
        nome: `${inboxNameById.value.get(c.idInbox) ?? 'Inbox'} · ${c.nome}`,
    }));

    if (!campanhas.length) return [];

    return [{ id: TODAS_CAMPANHAS, nome: 'Todas as campanhas' }, ...campanhas];
});

/**
 * Filtro "Em espera". Acessado por um computed pelo mesmo motivo do bloco
 * `automacoes`: filtros persistidos antes desta feature não têm o campo, e sem o
 * fallback o `v-model` escreveria em `undefined`.
 */
const emEspera = computed({
    get: () => !!chatStore.listFilters.emEspera,
    set: (valor: boolean) => { chatStore.listFilters.emEspera = valor; },
});

const generalFiltersCount = computed(() => {
    let count = 0;
    if (chatStore.listFilters?.naoLidos) count++;
    if (chatStore.listFilters?.emEspera) count++;
    if (chatStore.listFilters?.meus) count++;
    if (chatStore.listFilters?.botAvaliacao) count++;

    // Soma apenas a quantidade de agentes selecionados
    count += (chatStore.listFilters.selectedAgentIds?.length || 0);
    count += contarFiltrosAutomacoes(automacoes.value);

    return count;
});

const handleCreateTagClick = () => {
    uiStore.openAddTagModal();
};

/**
 * Atendimento criado por campanha e ainda sem resposta não entra em contador nenhum:
 * ele não está renderizado na lista, e um badge apontando para linhas invisíveis é
 * pior que badge nenhum.
 */
const chatsContaveis = computed(() => chatStore.chatList.filter(c => !ehAtendimentoOcultoPorCampanha(c)));

const getUnreadCount = (inboxId: string) => {
    return chatsContaveis.value
        .filter(c => c.idInbox == inboxId)
        .reduce((acc, chat) => acc + (chat.unreadCount || 0), 0);
};

function getAtendenteUnreadCount(idAtendente: IdUsuario) {
    return chatsContaveis.value.filter(c => c.atendentes.some(a => a.id == idAtendente)).reduce((acc, chat) => acc + (chat.unreadCount || 0), 0);
}

function getChannelUnreadCount(idCanal: IdCanal) {
    return chatsContaveis.value.filter(c => c.idCanal == idCanal).reduce((acc, chat) => acc + (chat.unreadCount || 0), 0);
}
</script>

<style scoped>
/* Estilos da barra de pesquisa e botões (Restaurados) */
.px-4 {
    padding-left: 16px !important;
    padding-right: 16px !important;
}
.form-control, .btn {
    min-height: 40px; 
    border-radius: 6px !important;
}
.form-control { border-right: 0; }
.input-group-text { border-left: 0; }
.btn-light {
    border: 1px solid var(--bs-border-color);
}
[data-bs-theme=dark] .btn-light {
    border: 1px solid #404a55;
    color: var(--bs-light-text-emphasis);
}
.bg-light{
    background: var(--bs-light) !important;
}
.btn {
    text-decoration: none;
}

.filter-dropdown-container {
    max-height: 450px;
    width: 300px;
    overflow-y: auto;
    padding: 10px 0;
}

.filter-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: var(--bs-primary);
    color: white;
    font-size: 9px;
    font-weight: bold;
    height: 18px;
    min-width: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}

.dropdown-header-v {
    font-size: 11px;
    font-weight: 800;
    padding: 10px 16px 5px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background-color: var(--bs-light);
}

.custom-scrollbar {
    overflow-y: auto;
    margin-right: 2px;
}
.custom-scrollbar::-webkit-scrollbar { width: 6px; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e7eaee; border-radius: 4px; }
[data-bs-theme="dark"] .custom-scrollbar::-webkit-scrollbar-thumb { background: #3b4045; }

.filter-dropdown-content {
    max-height: 450px;
    width: 300px;
    padding: 8px 0;
}

/* Select de campanha. O placeholder do multiselect é um div flex sem `nowrap`,
   e na fonte padrão do pacote (1rem) "Selecione uma campanha..." não cabia nos
   ~190px que sobram do dropdown de 300px — dobrava em duas linhas. A fonte
   segue o mesmo `--ms-font-size` usado nos filtros das páginas do admin; o
   `nowrap` + `overflow` são a garantia caso o texto volte a não caber. */
.filtro-campanha {
    --ms-font-size: 0.78rem;
}
.filtro-campanha :deep(.multiselect-placeholder) {
    white-space: nowrap;
    overflow: hidden;
}

.px-2 {
    padding-right: .7rem !important;
    padding-left: .7rem !important;
}

.tiny-avatar-container {
    display: flex;
    align-items: flex-end; 
    padding-bottom: 2px;
    z-index: 1;
}

.tiny-avatar-img {
    width: 32px;
    height: 32px;
    object-fit: cover;

    background: var(--bs-sidebar-bg);
    padding: 1px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.agent-status-label {
    font-size: 11px;
    line-height: 1.3;
}

@media (max-width: 992px) {
    .list-header{
        padding-top: 1rem !important;
    }
}
</style>